import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";

const centerVertically = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
};

export default function Email() {
  const [senha_nova, setNewPassword] = useState(''); // Estado para armazenar o valor da senha_nova
  const [confirma_senha, setConfirmedPassword] = useState('');
  const { post } = useFetch();
  const navigate = useNavigate();
  let { token } = useParams();

  async function enviarEmail() {
    try {
      if (senha_nova === '') {
          Swal.fire({
            title: "O espaço da senha está vazio",
            text: "Erro ao salvar nova senha ",
            icon: "error",
        })
      } else if (senha_nova !== confirma_senha) {
          Swal.fire({
            title: "As senhas não coincidem",
            text: "Erro ao salvar nova senha",
            icon: "error",
        })
      } else {
        const body = {
          senha_nova: senha_nova, // Adicione o email ao corpo do objeto
        };
        let response = await post("/recuperarsenha/" + token, body);
          if(response.status === 404) {
              Swal.fire({
                title: "Usuário não encontrado	",
                text: "Erro ao enviar email ",
                icon: "error",
            })
          }
          else if (response.status === 200) {
              navigate("/login");
              Swal.fire({
                title: "Senha mudado com sucesso",
                text: "Senha mudado com sucesso",
                icon: "success",
            })
          }
        }
      }
     catch (error) {
      console.error("Erro no enviarEmail():", error);
    }
  }

  return (
    <div className="image-background full">
      <div style={centerVertically}>
        <div className="col-md-3 email-block">
          <h2 className="text-center mb-4">Informe seu email</h2>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Nova Senha</Form.Label>
              <Form.Control
                type="password"
                name="senha_nova"
                placeholder="Digite sua nova senha"
                value={senha_nova}
                className="input-login"
                onChange={(e) => setNewPassword(e.target.value)} // Atualiza o estado quando o campo de email muda
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Confirme a senha</Form.Label>
              <Form.Control
                type="password"
                name="confirma_senha"
                placeholder="Confirme sua nova senha"
                value={confirma_senha}
                className="input-login"
                onChange={(e) => setConfirmedPassword(e.target.value)} // Atualiza o estado quando o campo de email muda
                required
              />
            </Form.Group>
            <div className="col text-center mb-3">
              <Button className="btn-padrao btn-lg btn-login px-5" id="btnLogin" onClick={enviarEmail}>Enviar</Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

